module.exports = __webpack_public_path__ + "media/base/subcontractors_small-b6cca497.svg";